var $371a732b2494f452$exports = {};
$371a732b2494f452$exports = {
  "alpha": "Alfa",
  "black": "svart",
  "blue": "Bl\xE5",
  "blue purple": "bl\xE5lilla",
  "brightness": "Lysstyrke",
  "brown": "brun",
  "brown yellow": "brungul",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cyan",
  "cyan blue": "cyanbl\xE5",
  "dark": "m\xF8rk",
  "gray": "gr\xE5",
  "grayish": "gr\xE5aktig",
  "green": "Gr\xF8nn",
  "green cyan": "gr\xF8nncyan",
  "hue": "Fargetone",
  "light": "lys",
  "lightness": "Lyshet",
  "magenta": "magenta",
  "magenta pink": "magentarosa",
  "orange": "oransje",
  "orange yellow": "oransjegul",
  "pale": "blek",
  "pink": "rosa",
  "pink red": "rosar\xF8d",
  "purple": "lilla",
  "purple magenta": "lillamagenta",
  "red": "R\xF8d",
  "red orange": "r\xF8doransje",
  "saturation": "Metning",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " gjennomsiktig");
  },
  "very dark": "sv\xE6rt m\xF8rk",
  "very light": "sv\xE6rt lys",
  "vibrant": "levende",
  "white": "hvit",
  "yellow": "gul",
  "yellow green": "gulgr\xF8nn"
};
export { $371a732b2494f452$exports as default };